import {BaseSyntheticEvent, FC, useEffect, useMemo, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import useModals from '../../../../hooks/useModals'
import {Loading} from '../../../../components/Loading/Loading'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {useNavigate} from 'react-router-dom'
import {i18n} from '../../../../translate/i18n'
import {Input} from '../../../../components/Input/Input'
import {Dropdown} from 'react-bootstrap'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import {useSwitchStatus} from '../../../../components/Datatable/SwitchStatus'
import {InventoryLoteModal} from '../../../../components/Modals/InventoryLote/InventoryLoteModal'
import useAuth from '../../../../hooks/useAuth'
import {ModularDataTable} from '../../../../components/ModularDataTable'
import {POST} from '../../../../services/api'
import Swal from 'sweetalert2'
import {createColumns, createActions, mapVariationResponse, useVariations} from './factory'
import {VariationType, VariationResponseType} from './types'

const options = [
  {value: '', label: 'Ambos', select: 'Ambos'},
  {value: 'true', label: 'Sim', select: 'Sim'},
  {value: 'false', label: 'Não', select: 'Não'},
]

// ADICIONADO 'multiple-barcode'
type QuickActionModalType = 'import-csv' | 'multiple-qrcode' | 'multiple-barcode' | null
type QRCodeTargetType = 'retail' | 'wholesale'

type QRCodeBatchItem = {
  label: string
  url: string
}

const VariacoesContent: FC = () => {
  const navigate = useNavigate()
  const {loginInfo} = useAuth()
  const {showDeleteModal, showWrapperModal, closeWrapperModal} = useModals()
  const {switchStatus} = useSwitchStatus()
  const {pluginSpace, integrations, getPluginSpace} = usePluginsSpace()
  const {verifyAdm, verifyCommonAdmin} = useAuth()
  const [showInventoryLoteModal, setShowInventoryLoteModal] = useState(false)
  const [fileToImport, setFileToImport] = useState<File | null>(null)
  const [hasStockControlIntegration, setHasStockControlIntegration] = useState(false)
  const [quickActionModal, setQuickActionModal] = useState<QuickActionModalType>(null)

  const [qrModalLoading, setQrModalLoading] = useState(false)
  const [qrModalSearch, setQrModalSearch] = useState('')
  const [qrModalVariations, setQrModalVariations] = useState<VariationType[]>([])
  const [qrModalPagination, setQrModalPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  })
  const [selectedVariationsMap, setSelectedVariationsMap] = useState<Record<number, VariationType>>(
    {}
  )
  const [loadingGenerateMultipleQRCode, setLoadingGenerateMultipleQRCode] = useState(false)

  // NOVO STATE DE LOADING PARA O CÓDIGO DE BARRAS
  const [loadingGenerateMultipleBarcode, setLoadingGenerateMultipleBarcode] = useState(false)

  const [qrCodeTarget, setQrCodeTarget] = useState<QRCodeTargetType>('retail')

  const disableFieldsTotvs = pluginSpace?.totvs && pluginSpace.totvs.disableFieldsVariation

  const {
    variations,
    setVariationId,
    locationId,
    setLocationId,
    locations,
    loading,
    setLoading,
    pagination,
    sorting,
    getVariations,
    deleteVariation,
    changeVariation,
    importFile,
    handleDataChange,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
    filters,
    init,
    tableLoading,
    setVariations,
  } = useVariations()

  const isAdmin = verifyCommonAdmin() && verifyAdm()
  const isWholeSaler = Boolean(pluginSpace?.wholeSaler)

  const columns = useMemo(
    () => createColumns({disableFieldsTotvs, changeVariation, switchStatus, setVariations}),
    [disableFieldsTotvs]
  )

  const actions = useMemo(
    () => createActions({navigate, showDeleteModal, setVariationId, isAdmin}),
    [isAdmin]
  )

  function stockControlIntegrationActive() {
    const stockControlIntegration = integrations.find(
      (integration) => integration.plugintemplateId === 34 && integration.plugintypeId === 17
    )
    if (stockControlIntegration) {
      const content = stockControlIntegration.content
      setHasStockControlIntegration(content.isInventory && content.isInventory === '1')
    } else {
      setHasStockControlIntegration(false)
    }
  }

  useEffect(() => {
    init(stockControlIntegrationActive)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const normalizeBaseUrl = (url: string) => {
    if (!url) return ''
    return url.endsWith('/') ? url.slice(0, -1) : url
  }

  const resolveWebappBaseUrl = (currentPluginSpace: any, target: QRCodeTargetType = 'retail') => {
    if (target === 'wholesale') {
      const defaultWholesaleBaseUrl =
        process.env.REACT_APP_PROD === '1'
          ? 'https://web-wholesale.ninegrid.com.br'
          : process.env.REACT_APP_WEBAPP_WHOLE_SALE_URL ||
            'https://web-staging-wholesale.ninegrid.com.br'

      const possibleWholesaleCustomUrl =
        currentPluginSpace?.webappWholesaleUrl ||
        currentPluginSpace?.webappWholeSaleUrl ||
        currentPluginSpace?.wholeSaleUrl ||
        currentPluginSpace?.wholesaleUrl ||
        currentPluginSpace?.customWholesaleDomain ||
        ''

      return normalizeBaseUrl(possibleWholesaleCustomUrl || defaultWholesaleBaseUrl)
    }

    const defaultRetailBaseUrl =
      process.env.REACT_APP_PROD === '1'
        ? 'https://webapp.ninegrid.com.br'
        : process.env.REACT_APP_WEBAPP_URL || 'https://web-staging.ninegrid.com.br'

    const possibleRetailCustomUrl =
      currentPluginSpace?.webappUrl ||
      currentPluginSpace?.webappLink ||
      currentPluginSpace?.customDomain ||
      currentPluginSpace?.domain ||
      ''

    return normalizeBaseUrl(possibleRetailCustomUrl || defaultRetailBaseUrl)
  }

  const fetchVariationsForQrModal = async (
    page = 1,
    pageSize = qrModalPagination.pageSize,
    search = qrModalSearch
  ) => {
    try {
      setQrModalLoading(true)

      const query = `?field=id&order=ASC&page=${page - 1}&take=${pageSize}&search=${search}`
      const res = await POST(`/variations/filter-admin${query}`, {
        haveImage: filters.haveImage,
        havePrice: filters.havePrice,
        productStatus: filters.productStatus,
        variationStatus: filters.variationStatus,
        haveInventory: filters.haveInventory,
        classificationId: filters.classificationId,
        havePromotionPrice: filters.havePromotionPrice,
        locationId: locationId || -1,
      })

      setQrModalVariations(
        (res.data || []).map((row: VariationResponseType) => mapVariationResponse(row))
      )

      if (res.meta) {
        setQrModalPagination({
          page,
          pageSize,
          total: res.meta.itemCount,
        })
      }
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Não foi possível carregar as variações para gerar QR/Códigos de Barras.',
      })
    } finally {
      setQrModalLoading(false)
    }
  }

  const openMultipleQrModal = async () => {
    setQuickActionModal('multiple-qrcode')
    setQrModalSearch('')
    setSelectedVariationsMap({})
    setQrCodeTarget('retail')
    showWrapperModal('Gerar Múltiplos QR Codes')
    await fetchVariationsForQrModal(1, qrModalPagination.pageSize, '')
  }

  // NOVA FUNÇÃO: ABRIR MODAL CÓDIGO DE BARRAS
  const openMultipleBarcodeModal = async () => {
    setQuickActionModal('multiple-barcode')
    setQrModalSearch('')
    setSelectedVariationsMap({})
    setQrCodeTarget('retail')
    showWrapperModal('Gerar Códigos de Barras')
    await fetchVariationsForQrModal(1, qrModalPagination.pageSize, '')
  }

  const toggleVariationSelection = (variation: VariationType, checked: boolean) => {
    setSelectedVariationsMap((prev) => {
      const updated = {...prev}
      if (checked) {
        updated[variation.id] = variation
      } else {
        delete updated[variation.id]
      }
      return updated
    })
  }

  const toggleCurrentPageSelection = (checked: boolean) => {
    setSelectedVariationsMap((prev) => {
      const updated = {...prev}

      qrModalVariations.forEach((variation) => {
        if (checked) {
          updated[variation.id] = variation
        } else {
          delete updated[variation.id]
        }
      })

      return updated
    })
  }

  const selectedVariations = Object.values(selectedVariationsMap)
  const selectedVariationsCount = selectedVariations.length
  const isAllCurrentPageSelected =
    qrModalVariations.length > 0 &&
    qrModalVariations.every((variation) => Boolean(selectedVariationsMap[variation.id]))

  const generateMultipleQRCodes = async () => {
    if (selectedVariationsCount === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Seleção obrigatória',
        text: 'Selecione pelo menos uma variação para gerar os QR Codes.',
      })
      return
    }

    try {
      setLoadingGenerateMultipleQRCode(true)

      const contextPluginSpace = pluginSpace?.subdomain
        ? pluginSpace
        : await getPluginSpace(false, true)

      if (!contextPluginSpace?.subdomain) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível obter o subdomínio da loja para gerar os QR Codes.',
        })
        return
      }

      if (qrCodeTarget === 'wholesale' && !contextPluginSpace?.wholeSaler) {
        Swal.fire({
          icon: 'warning',
          title: 'Não disponível',
          text: 'Esta loja não possui configuração de atacado para gerar QR Codes.',
        })
        return
      }

      const baseUrl = resolveWebappBaseUrl(contextPluginSpace, qrCodeTarget)
      const encodedStore = window.btoa(contextPluginSpace.subdomain)

      const qrLinks: QRCodeBatchItem[] = selectedVariations
        .filter((variation) => variation.productId && variation.sku)
        .map((variation) => {
          const skuNormalized = variation.sku.trim()
          const skuParam = encodeURIComponent(skuNormalized)
          return {
            label:
              qrCodeTarget === 'wholesale'
                ? `${variation.name} | SKU: ${skuNormalized} (Atacado)`
                : `${variation.name} | SKU: ${skuNormalized}`,
            url: `${baseUrl}/${encodedStore}/product/${variation.productId}?sku=${skuParam}`,
          }
        })

      if (qrLinks.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Nenhuma variação válida foi selecionada para geração de QR Code.',
        })
        return
      }

      const qrCodeData = {
        type: 'dynamic-link-batch',
        label: 'Variações selecionadas',
        iniInterval: 1,
        endInterval: 1,
        intervals: [],
        url: baseUrl,
        rawUrl: true,
        links: qrLinks,
      }

      const data = window.btoa(JSON.stringify(qrCodeData))
      const encodedData = encodeURIComponent(data)
      if (encodedData.length > 900) {
        const cacheKey = `qr-cache-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
        localStorage.setItem(cacheKey, data)
        window.open(`/webapp/generate-qr-code/${cacheKey}`, '_blank', 'noreferrer')
      } else {
        window.open(`/webapp/generate-qr-code/${encodedData}`, '_blank', 'noreferrer')
      }

      closeWrapperModal()
      setQuickActionModal(null)
      setSelectedVariationsMap({})
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao gerar múltiplos QR Codes.',
      })
    } finally {
      setLoadingGenerateMultipleQRCode(false)
    }
  }

  // NOVA FUNÇÃO: GERAR CÓDIGOS DE BARRAS
  const generateMultipleBarcodes = async () => {
    if (selectedVariationsCount === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Seleção obrigatória',
        text: 'Selecione pelo menos uma variação para gerar os Códigos de Barras.',
      })
      return
    }

    try {
      setLoadingGenerateMultipleBarcode(true)

      const contextPluginSpace = pluginSpace?.subdomain
        ? pluginSpace
        : await getPluginSpace(false, true)

      if (!contextPluginSpace?.subdomain) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível obter o subdomínio da loja.',
        })
        return
      }

      if (qrCodeTarget === 'wholesale' && !contextPluginSpace?.wholeSaler) {
        Swal.fire({
          icon: 'warning',
          title: 'Não disponível',
          text: 'Esta loja não possui configuração de atacado.',
        })
        return
      }

      const baseUrl = resolveWebappBaseUrl(contextPluginSpace, qrCodeTarget)
      const encodedStore = window.btoa(contextPluginSpace.subdomain)

      const barcodeItems = selectedVariations
        .filter((variation) => variation.productId && variation.sku)
        .map((variation) => {
          const skuNormalized = variation.sku.trim()
          const skuParam = encodeURIComponent(skuNormalized)
          return {
            sku: skuNormalized,
            label:
              qrCodeTarget === 'wholesale'
                ? `${variation.name}\nSKU: ${skuNormalized} (Atacado)`
                : `${variation.name}\nSKU: ${skuNormalized}`,
            url: `${baseUrl}/${encodedStore}/product/${variation.productId}?sku=${skuParam}`,
          }
        })

      if (barcodeItems.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Nenhuma variação com SKU válido foi selecionada.',
        })
        return
      }

      const barcodeBatchData = {
        type: 'batch',
        target: qrCodeTarget,
        items: barcodeItems,
      }

      const data = window.btoa(JSON.stringify(barcodeBatchData))
      const encodedData = encodeURIComponent(data)

      if (encodedData.length > 900) {
        const cacheKey = `barcode-cache-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
        localStorage.setItem(cacheKey, data)
        window.open(`/webapp/generate-barcode/${cacheKey}`, '_blank', 'noreferrer')
      } else {
        window.open(`/webapp/generate-barcode/${encodedData}`, '_blank', 'noreferrer')
      }

      closeWrapperModal()
      setQuickActionModal(null)
      setSelectedVariationsMap({})
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao gerar múltiplos Códigos de Barras.',
      })
    } finally {
      setLoadingGenerateMultipleBarcode(false)
    }
  }

  const totalQrModalPages = Math.max(
    1,
    Math.ceil(qrModalPagination.total / qrModalPagination.pageSize)
  )

  if (loading) {
    return <Loading />
  }

  return (
    <div className='row g-5 gx-xxl-12'>
      <div className='card card-xxl-stretch mb-5 mb-xl-12'>
        <div className='card-header py-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>
              {i18n.t(`smart_order.variations`)}
            </span>
            <BreadCrumbs />
            <span className='text-muted mt-1 fw-bold fs-7'>
              {i18n.t(`smart_order.listened_variations`)}
            </span>
          </h3>
          <div className='card-toolbar'>
            <Button
              text={i18n.t(`buttons.add_variation`)}
              color='primary'
              iconColor='#FFF'
              icon='fas fa-plus'
              size='small'
              horizontalPadding={6}
              btnAttr={{
                type: 'button',
              }}
              click={() => navigate('/variation/criar')}
              btnClass='mb-5 fw-bolder'
            />

            <Dropdown
              className='btn btn-primary btn-sm fw-bolder me-5 p-0 mb-5 dropdown '
              style={{marginLeft: '1em'}}
            >
              <Dropdown.Toggle variant='default' size='sm'>
                <i className='bi bi-three-dots fs-4 p-0'></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className='p-0'>
                {loginInfo &&
                  ['admin', 'owner', 'suport'].includes(loginInfo.profile) &&
                  pluginSpace &&
                  pluginSpace.wholeSaler &&
                  hasStockControlIntegration && (
                    <Dropdown.Item
                      onClick={() => {
                        setShowInventoryLoteModal(true)
                      }}
                      className='p-0 d-flex flex-row justify-content-center'
                    >
                      <div
                        className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                        style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                      >
                        <i
                          className='bi bi-archive me-2'
                          style={{color: '#6993FF', fontSize: '1rem'}}
                        ></i>
                        <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                          Atualizar Estoque em Lote
                        </p>
                      </div>
                    </Dropdown.Item>
                  )}
                <Dropdown.Item
                  onClick={() => {
                    setQuickActionModal('import-csv')
                    showWrapperModal('Importar CSV')
                  }}
                  className='p-0 d-flex flex-row justify-content-center'
                >
                  <div
                    className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                    style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-filetype-csv'
                      viewBox='0 0 16 16'
                      style={{color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em'}}
                    >
                      <path
                        fill-rule='evenodd'
                        d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z'
                      />
                    </svg>
                    <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                      Importar CSV
                    </p>
                  </div>
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    openMultipleQrModal()
                  }}
                  className='p-0 d-flex flex-row justify-content-center'
                >
                  <div
                    className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                    style={{color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%'}}
                  >
                    <i
                      className='bi bi-qr-code-scan me-2'
                      style={{color: '#6993FF', fontSize: '1rem'}}
                    ></i>
                    <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                      Gerar Múltiplos QR Codes
                    </p>
                  </div>
                </Dropdown.Item>

                {/* NOVO ITEM DO MENU: CÓDIGOS DE BARRAS */}
                <Dropdown.Item
                  onClick={() => {
                    openMultipleBarcodeModal()
                  }}
                  className='p-0 d-flex flex-row justify-content-center'
                >
                  <div
                    className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                    style={{
                      color: '#6993FF',
                      backgroundColor: '#E1E9FF',
                      width: '90%',
                      marginTop: '0 !important',
                    }}
                  >
                    <i
                      className='bi bi-upc-scan me-2'
                      style={{color: '#6993FF', fontSize: '1.2rem'}}
                    ></i>
                    <p style={{color: '#6993FF', fontSize: '1rem'}} className='m-0'>
                      Gerar Códigos de Barras
                    </p>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className='card-body'>
          <div className='row gap-2 mb-5'>
            <div className='col-4'>
              <Input
                inputAttr={{
                  type: 'select',
                }}
                value={locationId}
                change={async (value: number) => {
                  setLocationId(value)
                  setLoading(true)
                  await getVariations(value)
                  setLoading(false)
                }}
                label={i18n.t(`smart_order.select_modality`)}
                options={locations}
              />
            </div>

            <div
              className='col-4 text-muted h-100 d-flex align-items-center justify-content-end '
              style={{
                flex: 'auto',
                marginTop: 'auto',
              }}
            >
              <div className='rounded border text-black shadow-sm p-3 bg-light-warning border-warning'>
                <span>{i18n.t(`smart_order.message_warning_find_variation`)}</span>
              </div>
            </div>
          </div>
          <div className='row gap-2 mb-5'>
            <div className='col-12 d-flex flex-wrap align-items-center gap-4'>
              <Input
                inputAttr={{type: 'select'}}
                id='filterHaveImage'
                value={filters.haveImage === undefined ? '' : filters.haveImage ? 'true' : 'false'}
                change={(value: string) =>
                  handleFilterChange({
                    ...filters,
                    haveImage: value === '' ? undefined : value === 'true',
                  })
                }
                label='Com imagem'
                options={options}
              />
              <Input
                inputAttr={{type: 'select'}}
                id='filterHavePrice'
                value={filters.havePrice === undefined ? '' : filters.havePrice ? 'true' : 'false'}
                change={(value: string) =>
                  handleFilterChange({
                    ...filters,
                    havePrice: value === '' ? undefined : value === 'true',
                  })
                }
                label='Com preço'
                options={options}
              />
              <Input
                inputAttr={{type: 'select'}}
                id='filterProductStatus'
                value={
                  filters.productStatus === undefined
                    ? ''
                    : filters.productStatus
                    ? 'true'
                    : 'false'
                }
                change={(value: string) =>
                  handleFilterChange({
                    ...filters,
                    productStatus: value === '' ? undefined : value === 'true',
                  })
                }
                label='Produto ativo'
                options={options}
              />
              <Input
                inputAttr={{type: 'select'}}
                id='filterVariationStatus'
                value={
                  filters.variationStatus === undefined
                    ? ''
                    : filters.variationStatus
                    ? 'true'
                    : 'false'
                }
                change={(value: string) =>
                  handleFilterChange({
                    ...filters,
                    variationStatus: value === '' ? undefined : value === 'true',
                  })
                }
                label='Variação ativa'
                options={options}
              />
              <Input
                inputAttr={{type: 'select'}}
                id='filterHaveInventory'
                value={
                  filters.haveInventory === undefined
                    ? ''
                    : filters.haveInventory
                    ? 'true'
                    : 'false'
                }
                change={(value: string) =>
                  handleFilterChange({
                    ...filters,
                    haveInventory: value === '' ? undefined : value === 'true',
                  })
                }
                label='Com estoque'
                options={options}
              />
              <Input
                inputAttr={{type: 'select'}}
                id='filterHavePromotionPrice'
                value={
                  filters.havePromotionPrice === undefined
                    ? ''
                    : filters.havePromotionPrice
                    ? 'true'
                    : 'false'
                }
                change={(value: string) =>
                  handleFilterChange({
                    ...filters,
                    havePromotionPrice: value === '' ? undefined : value === 'true',
                  })
                }
                label='Com preço promocional'
                options={options}
              />
            </div>
          </div>
          <div className='d-flex justify-content-end'>
            <Button
              text={'Pesquisar'}
              color='primary'
              size='small'
              horizontalPadding={6}
              btnAttr={{
                type: 'button',
              }}
              click={() => getVariations(locationId)}
              btnClass='fw-bolder'
            />
          </div>
          <hr className='bg-black w-100' />

          <ModularDataTable
            data={variations}
            columns={columns}
            actions={actions}
            pagination={pagination}
            onPaginationChange={handlePaginationChange}
            sorting={sorting}
            onSortingChange={handleSortingChange}
            onDataChange={handleDataChange}
            //onFilterChange={handleFilterChange}
            searchable={true}
            searchPlaceholder='Pesquisar variações...'
            loading={tableLoading}
            selectable={false}
            striped={false}
            hover={false}
            size='md'
            className='table-row-bordered table-row-gray-200'
          />
        </div>
      </div>

      {quickActionModal === 'import-csv' && (
        <ModalWrapper
          confirmAction={() => importFile(fileToImport, () => setFileToImport(null))}
          textAction={'Confirmar'}
          onCloseAction={() => setQuickActionModal(null)}
        >
          <div className='flex-grow-1'>
            <p>{i18n.t(`general.attention`)}</p>
            <p>
              Para importar os estoques mínimos, basta preencher o modelo abaixo com os seguintes
              padrões:
            </p>
            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
              <div
                style={{
                  width: '70%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                sku/ean, estoque mínimo , largura, altura, profundidade, peso
              </div>
              <div style={{width: '30%'}}>
                <Button
                  text={'Modelo'}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    window.open('/file/estoque_minimo_exemplo.xlsx', '')
                  }}
                  btnClass='fw-bolder me-5'
                />
              </div>
            </div>
          </div>
          <br />
          <div className='flex-grow-1 text-center'>
            <Input
              inputAttr={{
                type: 'file',
              }}
              acceptFile={'.xlsx,.xls'}
              change={(value: BaseSyntheticEvent) =>
                setFileToImport(value ? value.target.files[0] : null)
              }
            />
          </div>
        </ModalWrapper>
      )}

      {quickActionModal === 'multiple-qrcode' && (
        <ModalWrapper
          confirmAction={() => generateMultipleQRCodes()}
          textAction={
            loadingGenerateMultipleQRCode
              ? 'Gerando...'
              : `Gerar QR Codes (${qrCodeTarget === 'wholesale' ? 'Atacado' : 'Varejo'})`
          }
          onCloseAction={() => {
            setQuickActionModal(null)
            setSelectedVariationsMap({})
          }}
          shouldCloseModal={false}
          disableMainButton={
            selectedVariationsCount === 0 || loadingGenerateMultipleQRCode || qrModalLoading
          }
          disableButton={loadingGenerateMultipleQRCode}
          width={300}
          isFooterFixed
        >
          <div className='d-flex flex-column gap-4'>
            <div className='d-flex align-items-center justify-content-between flex-wrap gap-3 pt-4'>
              <div className='rounded border border-gray-300 px-4 py-3'>
                <span className='fw-bold text-gray-800'>
                  Selecionadas: {selectedVariationsCount}
                </span>
              </div>
              <div className='input-group' style={{minWidth: '350px'}}>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Pesquisar por SKU ou produto'
                  value={qrModalSearch}
                  onChange={(event) => {
                    const value = event.target.value
                    setQrModalSearch(value)

                    if (!value.trim()) {
                      fetchVariationsForQrModal(1, qrModalPagination.pageSize, '')
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      fetchVariationsForQrModal(1, qrModalPagination.pageSize, qrModalSearch)
                    }
                  }}
                  style={{height: '38px'}}
                />
                <button
                  type='button'
                  className='btn btn-primary fw-bolder d-flex align-items-center justify-content-center p-0'
                  style={{
                    height: '38px',
                    width: '42px',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                  onClick={() =>
                    fetchVariationsForQrModal(1, qrModalPagination.pageSize, qrModalSearch)
                  }
                  aria-label='Pesquisar variações'
                >
                  <i className='bi bi-search fs-4'></i>
                </button>
              </div>
            </div>

            {/* Botão de qrCode atacado somente se for WholeSaler */}
            {isWholeSaler && (
              <div className='d-flex align-items-center gap-2'>
                <Button
                  text='Varejo'
                  color={qrCodeTarget === 'retail' ? 'primary' : 'light-primary'}
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => setQrCodeTarget('retail')}
                  btnClass='fw-bolder'
                />
                <Button
                  text='Atacado'
                  color={qrCodeTarget === 'wholesale' ? 'warning' : 'light-warning'}
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => setQrCodeTarget('wholesale')}
                  btnClass='fw-bolder'
                />
              </div>
            )}

            {qrModalLoading ? (
              <div className='d-flex flex-column align-items-center justify-content-center py-15'>
                <div className='spinner-border text-primary mb-3' role='status'>
                  <span className='visually-hidden'>Carregando...</span>
                </div>
                <span className='text-muted fw-semibold'>Carregando variações...</span>
              </div>
            ) : (
              <>
                <div className='table-responsive'>
                  <table className='table table-row-bordered table-row-gray-200 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold text-muted text-uppercase fs-7'>
                        <th className='w-50px text-center'>
                          <div className='form-check form-check-sm form-check-custom form-check-solid d-flex justify-content-center'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              checked={isAllCurrentPageSelected}
                              onChange={(event) => toggleCurrentPageSelection(event.target.checked)}
                            />
                          </div>
                        </th>
                        <th>SKU</th>
                        <th>Produto</th>
                        <th>Código</th>
                        <th className='text-center'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {qrModalVariations.length === 0 ? (
                        <tr>
                          <td colSpan={5} className='text-center text-muted py-10'>
                            Nenhuma variação encontrada.
                          </td>
                        </tr>
                      ) : (
                        qrModalVariations.map((variation) => {
                          const isSelected = Boolean(selectedVariationsMap[variation.id])
                          return (
                            <tr key={variation.id} className={isSelected ? 'table-active' : ''}>
                              <td className='text-center'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid d-flex justify-content-center'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={isSelected}
                                    onChange={(event) =>
                                      toggleVariationSelection(variation, event.target.checked)
                                    }
                                  />
                                </div>
                              </td>
                              <td className='fw-semibold text-gray-800'>{variation.sku || '-'}</td>
                              <td>{variation.name || '-'}</td>
                              <td>{variation.code || '-'}</td>
                              <td className='text-center'>
                                <span
                                  className={`badge ${
                                    variation.status ? 'bg-success' : 'bg-danger'
                                  }`}
                                >
                                  {variation.status ? 'Ativa' : 'Inativa'}
                                </span>
                              </td>
                            </tr>
                          )
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {qrModalPagination.total > 0 && (
                  <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
                    <span className='text-muted fs-7'>
                      Mostrando página {qrModalPagination.page} de {totalQrModalPages} (
                      {qrModalPagination.total} registros)
                    </span>
                    <div className='d-flex align-items-center gap-2'>
                      <button
                        type='button'
                        className='btn btn-sm btn-light'
                        disabled={qrModalPagination.page <= 1 || qrModalLoading}
                        onClick={() =>
                          fetchVariationsForQrModal(
                            qrModalPagination.page - 1,
                            qrModalPagination.pageSize,
                            qrModalSearch
                          )
                        }
                      >
                        Anterior
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-light'
                        disabled={qrModalPagination.page >= totalQrModalPages || qrModalLoading}
                        onClick={() =>
                          fetchVariationsForQrModal(
                            qrModalPagination.page + 1,
                            qrModalPagination.pageSize,
                            qrModalSearch
                          )
                        }
                      >
                        Próxima
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </ModalWrapper>
      )}

      {/* NOVO MODAL: CÓDIGO DE BARRAS */}
      {quickActionModal === 'multiple-barcode' && (
        <ModalWrapper
          confirmAction={() => generateMultipleBarcodes()}
          textAction={
            loadingGenerateMultipleBarcode
              ? 'Gerando...'
              : `Gerar Cód. Barras (${qrCodeTarget === 'wholesale' ? 'Atacado' : 'Varejo'})`
          }
          onCloseAction={() => {
            setQuickActionModal(null)
            setSelectedVariationsMap({})
          }}
          shouldCloseModal={false}
          disableMainButton={
            selectedVariationsCount === 0 || loadingGenerateMultipleBarcode || qrModalLoading
          }
          disableButton={loadingGenerateMultipleBarcode}
          width={300}
          isFooterFixed
        >
          <div className='d-flex flex-column gap-4'>
            <div className='d-flex align-items-center justify-content-between flex-wrap gap-3 pt-4'>
              <div className='rounded border border-gray-300 px-4 py-3'>
                <span className='fw-bold text-gray-800'>
                  Selecionadas: {selectedVariationsCount}
                </span>
              </div>
              <div className='input-group' style={{minWidth: '350px'}}>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Pesquisar por SKU ou produto'
                  value={qrModalSearch}
                  onChange={(event) => {
                    const value = event.target.value
                    setQrModalSearch(value)

                    if (!value.trim()) {
                      fetchVariationsForQrModal(1, qrModalPagination.pageSize, '')
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      fetchVariationsForQrModal(1, qrModalPagination.pageSize, qrModalSearch)
                    }
                  }}
                  style={{height: '38px'}}
                />
                <button
                  type='button'
                  className='btn btn-primary fw-bolder d-flex align-items-center justify-content-center p-0'
                  style={{
                    height: '38px',
                    width: '42px',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                  onClick={() =>
                    fetchVariationsForQrModal(1, qrModalPagination.pageSize, qrModalSearch)
                  }
                  aria-label='Pesquisar variações'
                >
                  <i className='bi bi-search fs-4'></i>
                </button>
              </div>
            </div>

            {/* Target de Atacado / Varejo */}
            {isWholeSaler && (
              <div className='d-flex align-items-center gap-2'>
                <Button
                  text='Varejo'
                  color={qrCodeTarget === 'retail' ? 'primary' : 'light-primary'}
                  size='small'
                  btnAttr={{type: 'button'}}
                  click={() => setQrCodeTarget('retail')}
                  btnClass='fw-bolder'
                />
                <Button
                  text='Atacado'
                  color={qrCodeTarget === 'wholesale' ? 'warning' : 'light-warning'}
                  size='small'
                  btnAttr={{type: 'button'}}
                  click={() => setQrCodeTarget('wholesale')}
                  btnClass='fw-bolder'
                />
              </div>
            )}

            {/* O conteúdo da tabela permanece exatamente igual ao do QRCode */}
            {qrModalLoading ? (
              <div className='d-flex flex-column align-items-center justify-content-center py-15'>
                <div className='spinner-border text-primary mb-3' role='status'>
                  <span className='visually-hidden'>Carregando...</span>
                </div>
                <span className='text-muted fw-semibold'>Carregando variações...</span>
              </div>
            ) : (
              <>
                <div className='table-responsive'>
                  <table className='table table-row-bordered table-row-gray-200 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold text-muted text-uppercase fs-7'>
                        <th className='w-50px text-center'>
                          <div className='form-check form-check-sm form-check-custom form-check-solid d-flex justify-content-center'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              checked={isAllCurrentPageSelected}
                              onChange={(event) => toggleCurrentPageSelection(event.target.checked)}
                            />
                          </div>
                        </th>
                        <th>SKU</th>
                        <th>Produto</th>
                        <th>Código</th>
                        <th className='text-center'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {qrModalVariations.length === 0 ? (
                        <tr>
                          <td colSpan={5} className='text-center text-muted py-10'>
                            Nenhuma variação encontrada.
                          </td>
                        </tr>
                      ) : (
                        qrModalVariations.map((variation) => {
                          const isSelected = Boolean(selectedVariationsMap[variation.id])
                          return (
                            <tr key={variation.id} className={isSelected ? 'table-active' : ''}>
                              <td className='text-center'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid d-flex justify-content-center'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={isSelected}
                                    onChange={(event) =>
                                      toggleVariationSelection(variation, event.target.checked)
                                    }
                                  />
                                </div>
                              </td>
                              <td className='fw-semibold text-gray-800'>{variation.sku || '-'}</td>
                              <td>{variation.name || '-'}</td>
                              <td>{variation.code || '-'}</td>
                              <td className='text-center'>
                                <span
                                  className={`badge ${
                                    variation.status ? 'bg-success' : 'bg-danger'
                                  }`}
                                >
                                  {variation.status ? 'Ativa' : 'Inativa'}
                                </span>
                              </td>
                            </tr>
                          )
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {qrModalPagination.total > 0 && (
                  <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
                    <span className='text-muted fs-7'>
                      Mostrando página {qrModalPagination.page} de {totalQrModalPages} (
                      {qrModalPagination.total} registros)
                    </span>
                    <div className='d-flex align-items-center gap-2'>
                      <button
                        type='button'
                        className='btn btn-sm btn-light'
                        disabled={qrModalPagination.page <= 1 || qrModalLoading}
                        onClick={() =>
                          fetchVariationsForQrModal(
                            qrModalPagination.page - 1,
                            qrModalPagination.pageSize,
                            qrModalSearch
                          )
                        }
                      >
                        Anterior
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-light'
                        disabled={qrModalPagination.page >= totalQrModalPages || qrModalLoading}
                        onClick={() =>
                          fetchVariationsForQrModal(
                            qrModalPagination.page + 1,
                            qrModalPagination.pageSize,
                            qrModalSearch
                          )
                        }
                      >
                        Próxima
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </ModalWrapper>
      )}

      <InventoryLoteModal
        isOpen={showInventoryLoteModal}
        variations={variations}
        onClose={() => setShowInventoryLoteModal(false)}
        onSuccess={async () => {
          setLoading(true)
          await getVariations(locationId)
          setLoading(false)
        }}
      />

      <ModalDelete confirmAction={() => deleteVariation()} />
    </div>
  )
}

const Variacoes: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`smart_order.variations`), path: 'variation', isActive: true},
        ]}
      >
        {i18n.t(`smart_order.variations`)}
      </PageTitle>
      <VariacoesContent />
    </>
  )
}

export {Variacoes}
